import styled, { keyframes } from "styled-components";

const TableAnimation = keyframes`
  0%{
    transform: rotate(0);
    
  }

  100%{
   
    transform: rotate(360deg);
  }
`;
export const LoaderContent = styled.div`
  border-radius: 12px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  .circle {
    width: 40px;
    height: 40px;
    border: 3px solid ${({ theme }) => theme.primary.dark};
    border-top-color: transparent;
    animation-name: ${TableAnimation};
    animation-iteration-count: infinite;
    animation-duration: 0.5s;
    animation-timing-function: linear;
    border-radius: 50%;
  }
`;
